import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.user.as.list');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-afterservice-user-as-list',
template: templateSource || '',
    styles: [``],
})
export class PortalAfterserviceUserAsListComponent implements OnInit, OnDestroy {

    public list_ing: any[] = [];
    public list_done: any[] = [];

    public facet_ing: any = { lastpage: 1 };
    public facet_done: any = { lastpage: 1 };

    public search: any = {
        page_ing: 1,
        page_done: 1
    };

    private querySub: Subscription | null = null;

    constructor(@Inject( Router)         private router: Router,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Service    )         public service: Service    ) {}

    async ngOnInit() {
        await this.service.init();

        this.querySub = this.route.queryParams.subscribe(params => {
            this.search = { ...this.search, ...params };

            if (!this.search.page_ing) this.search.page_ing = 1;
            if (!this.search.page_done) this.search.page_done = 1;

            this.load();
        });
    }

    ngOnDestroy() {
        if (this.querySub) this.querySub.unsubscribe();
    }

    formatDate(date: string) {
        return date ? moment(date).format('YYYY-MM-DD') : '';
    }

    onPageIng = async (page: number) => {
        this.search.page_ing = page;
        this.searchSubmit();
    }

    onPageDone = async (page: number) => {
        this.search.page_done = page;
        this.searchSubmit();
    }

    async load() {

        const res = await wiz.call('init', this.search);

        if (res.code === 200) {
            this.list_ing = res.data.ing.list || [];

            this.list_done = res.data.done.list || [];

            this.facet_ing.lastpage = res.data.ing.lastpage || 1;
            this.facet_done.lastpage = res.data.done.lastpage || 1;
        }
        await this.service.render();
    }

    searchSubmit() {
        this.router.navigate([], {
            queryParams: this.search
        });
    }

    getView(id: string) {
        this.router.navigate(['/user/as/view', id]);
    }
}

export default PortalAfterserviceUserAsListComponent;